function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createRegxpPatternFromWildcardedName } from "../../utils";
import Cookie from "js-cookie";
import { applyDynamics } from "../dynamics";
/**
 * Delete cookies on client side (currently only `localStorage` and `sessionStorage`).
 */

function deleteCookiesLocally(technicalDefinitions, dynamics) {
  var _iterator = _createForOfIteratorHelper(technicalDefinitions),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          type = _step$value.type,
          name = _step$value.name;
      // Create valid Regxp pattern
      var pattern = new RegExp(createRegxpPatternFromWildcardedName(applyDynamics(name, dynamics)), "g");

      switch (type) {
        case "http":
          {
            for (var _i = 0, _Object$keys = Object.keys(Cookie.get()); _i < _Object$keys.length; _i++) {
              var key = _Object$keys[_i];

              if (pattern.test(key)) {
                Cookie.remove(key);
              }
            }

            break;
          }

        case "local":
        case "session":
          {
            var useStorage = type === "local" ? window.localStorage : window.sessionStorage;

            if (useStorage) {
              for (var _i2 = 0, _Object$keys2 = Object.keys(useStorage); _i2 < _Object$keys2.length; _i2++) {
                var itemName = _Object$keys2[_i2];

                if (pattern.test(itemName)) {
                  try {
                    // Fallback to `null` because `removeItem` can have issues on some browsers
                    useStorage.setItem(itemName, null);
                  } catch (e) {// Silence is golden. A `QuotaExceededError` can be thrown but we ignore it, because we remove the item
                  } // Try as long (but max 100 times) until deleted


                  var tries = 0;

                  while (useStorage.getItem(itemName) && tries < 100) {
                    tries++;
                    useStorage.removeItem(itemName);
                  }
                }
              }
            }

            break;
          }

        default:
          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export { deleteCookiesLocally };